import { action } from "typesafe-actions";

import { ApplicationLayoutActionTypes, ThemeTypes, ThemeColors } from "./types";

// Actions
export const setThemeType = (type: ThemeTypes) => action(ApplicationLayoutActionTypes.SET_THEME, type);
export const setPrimaryColor = (color: ThemeColors) => action(ApplicationLayoutActionTypes.SET_PRIMARY, color);
export const setSecondaryColor = (color: ThemeColors) => action(ApplicationLayoutActionTypes.SET_SECONDARY, color);
export const setSidebar = (active: boolean) => action(ApplicationLayoutActionTypes.SET_SIDEBAR, active);
